import { Link } from 'react-router-dom';

const articles = [
  {
    slug: 'litbuy-spreadsheet-complete-guide',
    title: 'LitBuy Spreadsheet Complete Guide: Track Deals Like a Pro',
    excerpt: 'Everything you need to master LitBuy Spreadsheet — from initial setup and template selection to advanced deal tracking strategies across all 14 product categories.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20desk%20with%20laptop%20showing%20spreadsheet%2C%20notebook%2C%20and%20colorful%20pens%2C%20productive%20workspace%2C%20bright%20natural%20light%2C%20creative%20environment&width=600&height=420&seq=blog-grid-img-001&orientation=landscape',
    readTime: '12 min read',
    tag: 'Comprehensive',
  },
  {
    slug: 'litbuy-spreadsheet-review',
    title: 'LitBuy Spreadsheet Review 2026: Is It Worth It?',
    excerpt: 'An honest, in-depth review of LitBuy Spreadsheet covering features, pricing, pros and cons, and how it compares to alternatives for deal tracking and shopping.',
    image: 'https://readdy.ai/api/search-image?query=Person%20holding%20a%20tablet%20with%20five%20star%20review%20graphic%2C%20modern%20office%20background%2C%20recommendation%20concept%2C%20warm%20lighting%2C%20professional%20lifestyle&width=600&height=420&seq=blog-grid-img-002&orientation=landscape',
    readTime: '8 min read',
    tag: 'Review',
  },
  {
    slug: 'how-to-use-litbuy-spreadsheet',
    title: 'How to Use LitBuy Spreadsheet: Step-by-Step Tutorial',
    excerpt: 'A practical walkthrough showing exactly how to set up and use LitBuy Spreadsheet for tracking deals across Shoes, Hoodies, T-Shirts, and more.',
    image: 'https://readdy.ai/api/search-image?query=Hands%20typing%20on%20keyboard%20with%20tutorial%20video%20playing%20on%20screen%2C%20step%20by%20step%20guide%20visual%2C%20clean%20desk%20setup%2C%20educational%20atmosphere&width=600&height=420&seq=blog-grid-img-003&orientation=landscape',
    readTime: '10 min read',
    tag: 'Tutorial',
  },
  {
    slug: 'best-litbuy-spreadsheet-templates',
    title: 'Best LitBuy Spreadsheet Templates for Every Category',
    excerpt: 'Discover the top LitBuy Spreadsheet templates optimized for each of the 14 product categories — from Shoes and Jackets to Perfumes and Accessories.',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20beautifully%20designed%20template%20cards%20spread%20on%20a%20white%20desk%2C%20creative%20design%20workspace%2C%20colorful%20stationery%2C%20morning%20sunlight&width=600&height=420&seq=blog-grid-img-004&orientation=landscape',
    readTime: '7 min read',
    tag: 'Templates',
  },
  {
    slug: 'litbuy-spreadsheet-vs-google-sheets',
    title: 'LitBuy Spreadsheet vs Google Sheets: Full Comparison',
    excerpt: 'A detailed side-by-side comparison of LitBuy Spreadsheet and Google Sheets for deal tracking, with feature tables and real-world use cases.',
    image: 'https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20showing%20different%20spreadsheet%20interfaces%2C%20comparison%20concept%2C%20modern%20tech%20workspace%2C%20clean%20minimal%20setup&width=600&height=420&seq=blog-grid-img-005&orientation=landscape',
    readTime: '9 min read',
    tag: 'Comparison',
  },
  {
    slug: 'top-features-litbuy-spreadsheet',
    title: 'Top 10 Features of LitBuy Spreadsheet You Should Know',
    excerpt: 'Explore the most powerful LitBuy Spreadsheet features including category tracking, price alerts, analytics dashboard, and cross-retailer comparison.',
    image: 'https://readdy.ai/api/search-image?query=Feature%20checklist%20with%20checkmarks%20on%20a%20digital%20screen%2C%20modern%20UI%20design%2C%20bright%20clean%20interface%2C%20product%20showcase%20photography&width=600&height=420&seq=blog-grid-img-006&orientation=landscape',
    readTime: '8 min read',
    tag: 'Features',
  },
  {
    slug: 'common-mistakes-litbuy-spreadsheet',
    title: '7 Common LitBuy Spreadsheet Mistakes and How to Avoid Them',
    excerpt: 'Learn the most frequent errors LitBuy Spreadsheet users make — and the simple fixes that dramatically improve your deal tracking accuracy.',
    image: 'https://readdy.ai/api/search-image?query=Warning%20sign%20and%20checklist%20on%20paper%2C%20problem%20solving%20concept%2C%20organized%20workspace%2C%20bright%20natural%20lighting%2C%20improvement%20theme&width=600&height=420&seq=blog-grid-img-007&orientation=landscape',
    readTime: '7 min read',
    tag: 'Tips',
  },
  {
    slug: 'litbuy-spreadsheet-setup-guide',
    title: 'LitBuy Spreadsheet Setup Guide: Get Started in 5 Minutes',
    excerpt: 'A quick-start setup guide that gets your LitBuy Spreadsheet running in under 5 minutes — perfect for beginners and new users.',
    image: 'https://readdy.ai/api/search-image?query=Rocket%20launch%20icon%20on%20laptop%20screen%2C%20quick%20start%20concept%2C%20modern%20workspace%2C%20energetic%20lighting%2C%20speed%20and%20efficiency%20theme&width=600&height=420&seq=blog-grid-img-008&orientation=landscape',
    readTime: '6 min read',
    tag: 'Setup',
  },
  {
    slug: 'advanced-tips-litbuy-spreadsheet',
    title: 'Advanced Tips for LitBuy Spreadsheet Power Users',
    excerpt: 'Take your LitBuy Spreadsheet skills to the next level with advanced strategies for seasonal tracking, bundle optimization, and multi-retailer price mapping.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20analyzing%20complex%20data%20charts%20on%20multiple%20monitors%2C%20advanced%20analytics%20workspace%2C%20dark%20mode%20screens%2C%20expert%20level%20atmosphere&width=600&height=420&seq=blog-grid-img-009&orientation=landscape',
    readTime: '9 min read',
    tag: 'Advanced',
  },
  {
    slug: 'best-alternatives-litbuy-spreadsheet',
    title: 'Best Alternatives to LitBuy Spreadsheet in 2026',
    excerpt: 'Compare the top LitBuy Spreadsheet alternatives including Google Sheets, Excel, Airtable, and specialized deal tracking tools with honest ratings.',
    image: 'https://readdy.ai/api/search-image?query=Multiple%20app%20icons%20arranged%20in%20a%20comparison%20grid%2C%20alternative%20options%20concept%2C%20clean%20white%20background%2C%20modern%20tech%20flat%20lay%2C%20colorful%20minimal&width=600&height=420&seq=blog-grid-img-010&orientation=landscape',
    readTime: '8 min read',
    tag: 'Alternatives',
  },
];

export default function BlogGridSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-4">Blog & Guides</span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            LitBuy Spreadsheet Resources
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[560px] mx-auto">
            Expert guides, tutorials, and comparisons to help you get the most out of your LitBuy Spreadsheet experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              className="group rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 hover:shadow-sm transition-all duration-300 overflow-hidden cursor-pointer flex flex-col"
            >
              <div className="w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-accent-100 text-accent-700">
                    {article.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-xs font-semibold text-primary-500 group-hover:text-primary-600 transition-colors">
                  Read Article <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}